//@ts-nocheck
import { useState } from 'react';
import type { NextPage } from 'next';
import Link from 'next/link';
import Image from 'next/image';
import Layout from '@components/Layout';
import { GlobalStyle, ModalBaileys } from './ModalCopy.styles';
import Footer from '@components/Footer';
import poison from '@assets/poison_perfum.jpg';
import jordan22 from '@assets/jordan22.jpg';
import api from '@assets/api.jpg';
import python from '@assets/python.jpg';

import {
  Diorpoison,
  Diorsauvage,
  Nikejordan22,
  Breitling,
  ApiDocuments,
  PythonDocuments,
  Cybersecurityai,
  Emails,
  Iphone16,
  Rollsroycespectre,
  CollectionSS25,
  FashionStylist
} from './data';

type ReadProps = {
  showHChighlight?: boolean;
  diorpoison?: boolean;
  diorsauvage?: boolean;
  showJordan22?: boolean;
  showBreitling?: boolean;
  showApiDocuments?: boolean;
  showPythonDocuments?: boolean;
  showCybersecurityai?: boolean;
  showEmailMarketing?: boolean;
  showIphone16?: boolean;
  showRollsroycespectre?: boolean;
  showCollectionSS25?: boolean;
  showFashionStylist?: boolean;
  isClosed?: () => void;
};

export const Thecopymodal = ({
  isClosed,
  diorpoison,
  diorsauvage,
  showJordan22,
  showBreitling,
  showApiDocuments,
  showPythonDocuments,
  showCybersecurityai,
  showEmailMarketing,
  showIphone16,
  showRollsroycespectre,
  showCollectionSS25,
  showFashionStylist
}: ReadProps) => {
  return (
    <>
      <GlobalStyle />
      <Layout showHeader showNoheader showMenu showTheStoryHeader>
        <ModalBaileys>
          <section>
            {/* Copywriting */}
            {diorpoison && <Diorpoison showImg={poison} isClosed={isClosed} />}
            {diorsauvage && (
              <Diorsauvage
                showMedia="/media/diorsauvage.mp4"
                isClosed={isClosed}
              />
            )}
            {showJordan22 && (
              <Nikejordan22 showImg={jordan22} isClosed={isClosed} />
            )}
            {showBreitling && (
              <Breitling showMedia="/media/breitling.mp4" isClosed={isClosed} />
            )}
            {showIphone16 && (
              <Iphone16 showMedia="/media/iphone16.mp4" isClosed={isClosed} />
            )}
            {showRollsroycespectre && (
              <Rollsroycespectre
                showMedia="/media/rollsroyce_spectre.mp4"
                isClosed={isClosed}
              />
            )}

            {/* Technical Writing */}
            {showApiDocuments && (
              <ApiDocuments showImg={api} isClosed={isClosed} />
            )}
            {showPythonDocuments && (
              <PythonDocuments showImg={python} isClosed={isClosed} />
            )}
            {showCybersecurityai && <Cybersecurityai isClosed={isClosed} />}

            {/* Email Marketing */}
            {showEmailMarketing && <Emails isClosed={isClosed} />}

            {/* Fashion writing & Fashion Styling */}
            {showCollectionSS25 && <CollectionSS25 />}
            {showFashionStylist && <FashionStylist isClosed={isClosed} />}

            <Footer mgT="40px" />
          </section>
        </ModalBaileys>
      </Layout>
    </>
  );
};
